module.exports = __webpack_public_path__ + "static/img-principal-sri.7d137e82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-principal-sri.jpg
// module id = 566
// module chunks = 52470039999506